
function formatLargeNumber(number) {

  if (!number) return '';
    if (number >= 1e12) {
      return (number / 1e12).toFixed(2) + ' Trillion';
    } else if (number >= 1e9) {
      return (number / 1e9).toFixed(2) + ' Billion';
    } else if (number >= 1e6) {
      return (number / 1e6).toFixed(2) + ' Million';
    } else {
      return number.toFixed(2);
    }
}

export default formatLargeNumber


